/* X Cutlery theme JS — vanilla, no dependencies */
(function () {
  'use strict';

  const money = (cents) => {
    const amount = (cents / 100).toFixed(2);
    return (window.XCutlery && window.XCutlery.moneyFormat
      ? window.XCutlery.moneyFormat.replace(/\{\{\s*amount\s*\}\}/, amount)
      : '$' + amount);
  };

  /* ---------- Cart Drawer ---------- */
  const drawer = {
    el: null,
    init() {
      this.el = document.querySelector('[data-cart-drawer]');
      if (!this.el) return;
      this.el.querySelectorAll('[data-cart-close]').forEach((b) =>
        b.addEventListener('click', () => this.close())
      );
      document.addEventListener('keyup', (e) => { if (e.key === 'Escape') this.close(); });
      this.refresh();
    },
    open() { if (this.el) this.el.classList.add('is-open'); document.body.style.overflow = 'hidden'; },
    close() { if (this.el) this.el.classList.remove('is-open'); document.body.style.overflow = ''; },
    async refresh() {
      try {
        const res = await fetch('/cart.js');
        const cart = await res.json();
        this.render(cart);
      } catch (e) { console.error('Cart fetch failed', e); }
    },
    render(cart) {
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? '' : 'none';
      });
      if (!this.el) return;
      const itemsEl = this.el.querySelector('[data-cart-items]');
      const subtotalEl = this.el.querySelector('[data-cart-subtotal]');
      const footerEl = this.el.querySelector('[data-cart-footer]');
      if (cart.item_count === 0) {
        itemsEl.innerHTML = '<div class="cart-empty"><p>Your cart is empty.</p><a class="btn" href="/collections/all">Shop Knives</a></div>';
        if (footerEl) footerEl.style.display = 'none';
        return;
      }
      if (footerEl) footerEl.style.display = '';
      itemsEl.innerHTML = cart.items.map((item) => {
        const props = Object.keys(item.properties || {})
          .filter((k) => k.charAt(0) !== '_' && item.properties[k])
          .map((k) => `<div class="cart-line__prop">${k}: ${item.properties[k]}</div>`)
          .join('');
        return `
          <div class="cart-line" data-key="${item.key}">
            <img src="${item.image ? item.image.replace(/(\.[^.]*)$/, '_120x$1') : ''}" alt="${item.product_title}">
            <div class="cart-line__info">
              <div class="cart-line__title">${item.product_title}</div>
              ${item.variant_title && item.variant_title !== 'Default Title' ? `<div>${item.variant_title}</div>` : ''}
              ${props}
              <div>Qty: ${item.quantity} &times; ${money(item.price)}</div>
              <button class="cart-line__remove" data-remove="${item.key}">Remove</button>
            </div>
            <div class="cart-line__price">${money(item.line_price)}</div>
          </div>`;
      }).join('');
      if (subtotalEl) subtotalEl.textContent = money(cart.total_price);
      itemsEl.querySelectorAll('[data-remove]').forEach((btn) =>
        btn.addEventListener('click', () => this.changeQty(btn.getAttribute('data-remove'), 0))
      );
    },
    async changeQty(key, qty) {
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty }),
        });
        const cart = await res.json();
        this.render(cart);
      } catch (e) { console.error(e); }
    },
    async add(formData) {
      const res = await fetch('/cart/add.js', { method: 'POST', body: formData });
      if (!res.ok) { const err = await res.json(); throw new Error(err.description || 'Add to cart failed'); }
      await this.refresh();
      this.open();
    },
  };

  /* ---------- AJAX add-to-cart on any [data-product-form] ---------- */
  function bindForms() {
    document.querySelectorAll('form[data-product-form]').forEach((form) => {
      if (form.dataset.bound) return;
      form.dataset.bound = '1';
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const btn = form.querySelector('[type="submit"]');
        const original = btn ? btn.textContent : '';
        if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
        try {
          await drawer.add(new FormData(form));
          if (btn) btn.textContent = 'Added ✓';
        } catch (err) {
          alert(err.message);
          if (btn) btn.textContent = original;
        } finally {
          setTimeout(() => { if (btn) { btn.disabled = false; btn.textContent = original; } }, 1200);
        }
      });
    });
  }

  /* ---------- Cart open triggers ---------- */
  function bindTriggers() {
    document.querySelectorAll('[data-cart-open]').forEach((el) =>
      el.addEventListener('click', (e) => { e.preventDefault(); drawer.open(); })
    );
  }

  /* ---------- Mobile menu ---------- */
  /* ---------- Mobile menu & Dropdowns ---------- */
  function bindMenu() {
    const toggle = document.querySelector('[data-menu-toggle]');
    const nav = document.querySelector('[data-mobile-nav]');
    
    // 1. Toggle main hamburger menu
    if (toggle && nav) {
      toggle.addEventListener('click', () => {
        nav.classList.toggle('is-open');
      });
    }

    // 2. Toggle sub-menus on mobile without navigating away
    const dropdownItems = document.querySelectorAll('.nav__item.has-dropdown');
    dropdownItems.forEach(item => {
      const link = item.querySelector('.nav__link');
      const dropdown = item.querySelector('.nav__dropdown');
      
      if (link && dropdown) {
        link.addEventListener('click', (e) => {
          // Only apply click-to-open logic on mobile screens
          if (window.innerWidth < 768) {
            e.preventDefault(); // Prevent following the link immediately
            item.classList.toggle('is-open');
            dropdown.classList.toggle('is-open');
          }
        });
      }
    });
  }

  /* ---------- Knife Builder ---------- */
  function initKnifeBuilder() {
    document.querySelectorAll('[data-knife-builder]').forEach((builder) => {
      const base = parseFloat(builder.dataset.basePrice || '0');
      const totalEl = builder.querySelector('[data-kb-total]');
      const summaryEl = builder.querySelector('[data-kb-summary]');
      const recalc = () => {
        let total = base;
        const parts = [];
        builder.querySelectorAll('input[type="radio"]:checked').forEach((inp) => {
          total += parseFloat(inp.dataset.price || '0');
          if (inp.dataset.label) parts.push(`${inp.dataset.group}: ${inp.dataset.label}`);
        });
        const eng = builder.querySelector('[data-kb-engraving]');
        if (eng && eng.value.trim()) { total += parseFloat(eng.dataset.price || '0'); parts.push(`Engraving: "${eng.value.trim()}"`); }
        if (totalEl) totalEl.textContent = money(Math.round(total * 100));
        if (summaryEl) summaryEl.textContent = parts.join('  ·  ');
        // sync hidden line-item properties
        builder.querySelectorAll('input[type="radio"]:checked').forEach((inp) => {
          const hidden = builder.querySelector(`input[type="hidden"][data-prop="${inp.dataset.group}"]`);
          if (hidden) hidden.value = inp.dataset.label;
        });
        const hiddenEng = builder.querySelector('input[type="hidden"][data-prop="Engraving"]');
        if (hiddenEng && eng) hiddenEng.value = eng.value.trim();
      };
      builder.querySelectorAll('input[type="radio"]').forEach((i) => i.addEventListener('change', recalc));
      const eng = builder.querySelector('[data-kb-engraving]');
      if (eng) eng.addEventListener('input', recalc);
      recalc();
    });
  }

  /* ---------- Quantity selectors ---------- */
  function bindQty() {
    document.querySelectorAll('[data-qty]').forEach((q) => {
      const input = q.querySelector('input');
      const minus = q.querySelector('[data-qty-minus]');
      const plus = q.querySelector('[data-qty-plus]');
      if (minus) minus.addEventListener('click', () => { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
      if (plus) plus.addEventListener('click', () => { input.value = (parseInt(input.value, 10) || 1) + 1; });
    });
  }


document.addEventListener('DOMContentLoaded', () => {
    drawer.init();
    bindForms();
    bindTriggers();
    // bindMenu(); // <-- Commented out to let the default theme handle the hamburger menu
    bindQty();
    initKnifeBuilder();
  });
  

  window.XCutleryCart = drawer;
})();




